/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationsByResourceCategoryResponse {
    getFixupPrototypeFunction() { return SecurityDashboardViolationsByResourceCategoryResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationsByResourceCategoryResponse>): SecurityDashboardViolationsByResourceCategoryResponse {
        let obj = Object.assign(new SecurityDashboardViolationsByResourceCategoryResponse(), model);
        SecurityDashboardViolationsByResourceCategoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationsByResourceCategoryResponse>): SecurityDashboardViolationsByResourceCategoryResponse {
        if (!model) return null;
        return SecurityDashboardViolationsByResourceCategoryResponse.newInstance(<SecurityDashboardViolationsByResourceCategoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationsByResourceCategoryResponse) {
        if (!obj) return;

        models.SecurityDashboardViolationsByResourceCategoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationsByResourceCategoryResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationsByResourceCategoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_provider_category) {
            for (let val of this.summary_by_provider_category) {
                models.SecurityDashboardViolationByResourceCategoryCount.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Config Violation by CloudProvider
     */
    summary_by_provider_category: Array<models.SecurityDashboardViolationByResourceCategoryCount>;

}
